var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFirstAid = function SvgFirstAid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "first-aid_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.036 22.964h16.63v18.072h-16.63v16.63H22.964v-16.63H6.334V22.964h16.63V6.334h18.072z"
  })));
};
export { SvgFirstAid as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNDEuMDM1OSAyMi45NjQzSDU3LjY2NjdWNDEuMDM1OUg0MS4wMzU5VjU3LjY2NjdIMjIuOTY0M1Y0MS4wMzU5SDYuMzMzMzdWMjIuOTY0M0gyMi45NjQzVjYuMzMzMzdMNDEuMDM1OSA2LjMzMzM4VjIyLjk2NDNaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";